
if (!customElements.get('product-form')) {

    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
  
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('click', this.onSubmitHandler.bind(this));
        //this.cartNotification = document.querySelector('cart-notification');
      }
  
      onSubmitHandler(evt) {

        evt.preventDefault();
      
        const submitButton = this.querySelector('[type="submit"]');

        // drawercart.js already owns clicks on .js-go-cart-add-to-cart and
        // POSTs /cart/add.js. Without this guard BOTH handlers fire on the
        // main Add to Bag and the customer gets 2 units for one click.
        // Measured 2026-08-07 on the No-Show PDP: cart held qty 2.
        if (submitButton.classList.contains('js-go-cart-add-to-cart')) return;

        if (submitButton.classList.contains('loading')) return;
  
        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);
  
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('free')
        submitButton.classList.add('loading');
        //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
  
        const formData = new FormData(this.form);
        //formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              document.querySelector('.ajax-add-notice').classList.add('hidden')
              return;
            }else{
              document.querySelector('.ajax-add-notice').classList.remove('hidden')
            }
            //this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        
      }
  
      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
  
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
  
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
     
        }
      
      }
   
    });
  }
  